// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* AI 추천 카드 콘텐츠 스타일 */
.ai-card-container {
  max-width: 900px;
  margin: 40px auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 32px 24px 32px;
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}

.ai-card-header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 18px;
  position: relative;
}

.ai-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  border-bottom: 2px solid #b6d7a8;
  padding-bottom: 2px;
  margin-right: 12px;
}

.ai-card-desc {
  font-size: 1rem;
  color: #444;
}

.ai-card-ai {
  color: #4e7c1b;
  font-weight: 600;
}

.ai-card-dropdown-wrap {
  margin-left: auto;
  position: relative;
}

.ai-card-dropdown-btn {
  background: #eaf5e6;
  border: 1px solid #b6d7a8;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 1rem;
  cursor: pointer;
  color: #4e7c1b;
  font-weight: 600;
  transition: background 0.2s;
}

.ai-card-dropdown-btn:hover {
  background: #d9f2c7;
}

.arrow {
  font-size: 0.9em;
  margin-left: 4px;
}

.ai-card-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  width: 340px;
  background: #fff;
  border: 1px solid #b6d7a8;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  z-index: 10;
  padding: 12px 0 12px 0;
}

.ai-card-dropdown-title {
  font-weight: 700;
  font-size: 1.1rem;
  padding: 0 18px 8px 18px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 8px;
}

.ai-card-dropdown-q {
  color: #b6d7a8;
  font-size: 1em;
  margin-left: 4px;
}

.ai-card-dropdown-list {
  max-height: 320px;
  overflow-y: auto;
  padding: 0 18px;
}

.ai-card-dropdown-item {
  font-size: 1rem;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.rank-num {
  font-weight: 700;
  color: #4e7c1b;
  min-width: 22px;
  display: inline-block;
}

.ai-card-main {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  margin-bottom: 24px;
}

.ai-card-carousel {
  width: 320px;
  height: 420px;
  background: #f4f4f4;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ai-card-carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  transition: opacity 0.5s;
}

.ai-card-carousel-placeholder {
  color: #aaa;
  font-size: 1.2rem;
}

.ai-card-book-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.ai-card-book-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 2px;
}

.ai-card-book-author {
  color: #666;
  font-size: 1.05rem;
}

.ai-card-book-pub {
  color: #999;
  font-size: 0.98rem;
}

.ai-card-book-status {
  margin-top: 8px;
  display: flex;
  gap: 12px;
}

.ai-card-book-loan {
  background: #eaeaea;
  color: #b6d7a8;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 0.95rem;
}

.ai-card-book-ebook {
  background: #f7f7f7;
  color: #aaa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 0.95rem;
}

.ai-card-footer {
  background: #f8f8f2;
  border-radius: 10px;
  padding: 14px 18px 10px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.ai-card-footer-info {
  font-size: 1.05rem;
  color: #444;
  margin-bottom: 4px;
}

.ai-card-footer-label {
  color: #888;
  margin-right: 8px;
}

.ai-card-footer-title {
  font-weight: 700;
  margin-right: 8px;
}

.ai-card-footer-author {
  color: #666;
}

.ai-card-footer-tags {
  display: flex;
  gap: 10px;
  margin-top: 2px;
}

.ai-card-footer-tag {
  padding: 3px 12px;
  border-radius: 8px;
  font-size: 0.98rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.ai-card-footer-tag.green {
  background: #eaf5e6;
  color: #4e7c1b;
}

.ai-card-footer-tag.gray {
  background: #eaeaea;
  color: #888;
}

.ai-card-footer-tag.search {
  background: #f7f7f7;
  color: #b6d7a8;
  cursor: pointer;
}

.click {
  background: #b6d7a8;
  color: #fff;
  border-radius: 6px;
  padding: 1px 7px;
  margin-left: 6px;
  font-size: 0.95em;
}

/* AI 캐러셀 스타일 */
.ai-carousel-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 48px;
  max-width: 1100px;
  margin: 40px auto;
  min-height: 400px;
}

.ai-carousel-bookcard {
  width: 260px;
  min-width: 220px;
  height: 370px;
  background: linear-gradient(160deg, #6d7290 80%, #8a8fa8 100%);
  border-radius: 10px 10px 8px 8px;
  box-shadow: 0 6px 24px rgba(60, 60, 80, 0.13);
  display: flex;
  align-items: flex-end;
  position: relative;
  margin-right: 12px;
}

.ai-carousel-bookcard-inner {
  width: 100%;
  padding: 32px 20px 24px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 18px;
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}

.ai-carousel-book-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 8px;
  word-break: keep-all;
}

.ai-carousel-book-author {
  font-size: 1.05rem;
  color: #d2d6e0;
  margin-bottom: 2px;
}

.ai-carousel-book-publisher {
  font-size: 1.02rem;
  color: #d2d6e0;
}

.ai-carousel-images {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 328px;
  height: 328px;
  background: #f4f4f4;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.ai-carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  transition: opacity 0.5s;
}

.ai-card-loading {
  text-align: center;
  font-size: 1.2rem;
  color: #888;
  margin-top: 120px;
}

/* 슬라이드형 북카드 캐러셀 스타일 */
.ai-slide-root {
  max-width: 1260px;
  margin: 100px auto 0 auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 0 0 24px 0;
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
  overflow-x: visible;
}

.ai-slide-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 14px 18px;
  padding: 32px 48px 0 48px;
  position: relative;
}

.ai-slide-header-main {
  flex: 1 1 280px;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  gap: 10px 12px;
  align-items: center;
}

.ai-slide-header-row1 {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  min-width: 0;
}

.ai-slide-catalog-tabs {
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #b6d7a8;
  flex-shrink: 0;
  background: #f4faf0;
}

.ai-slide-catalog-tab {
  padding: 7px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  color: #4a5a42;
  font-family: inherit;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease;
}

.ai-slide-catalog-tab:hover {
  background: rgba(107, 159, 62, 0.12);
  color: #3d5c24;
}

.ai-slide-catalog-tab.is-active {
  background: #6b9f3e;
  color: #fff;
}

.ai-slide-catalog-tab.is-active:hover {
  background: #5d8a35;
  color: #fff;
}

.ai-slide-title {
  font-size: 1.35rem;
  font-weight: 700;
  border-bottom: 2px solid #b6d7a8;
  padding-bottom: 2px;
  margin-right: 0;
  line-height: 1.35;
  min-width: 0;
  justify-self: start;
  width: fit-content;
  max-width: 100%;
  display: inline-block;
  box-sizing: border-box;
}

.ai-slide-desc {
  font-size: 1rem;
  color: #444;
  line-height: 1.55;
  word-break: keep-all;
  overflow-wrap: break-word;
  max-width: 100%;
  grid-column: 1 / -1;
  grid-row: 2;
}

.ai-slide-desc-sub {
  display: inline-block;
  margin-left: 10px;
  color: #6b7280;
  font-size: 0.92em;
  font-weight: 450;
  white-space: nowrap;
}

.ai-slide-root-note {
  max-width: 1260px;
  margin: 10px auto 0 auto;
  padding: 0 48px;
  color: #6b7280;
  font-size: 0.92rem;
  line-height: 1.5;
  word-break: keep-all;
  text-align: right;
}

@media (max-width: 719px) {
  .ai-slide-root-note {
    padding: 0 16px;
  }
}

.ai-slide-ai {
  color: #4e7c1b;
  font-weight: 600;
}

.ai-slide-dropdown-wrap {
  position: relative;
  flex-shrink: 0;
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  align-self: center;
  margin-left: 0;
}

.ai-slide-dropdown-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: #059669;
  background-color: #ecfdf5;
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #d1fae5;
  gap: 0.375rem;
  cursor: pointer;
}

.ai-slide-dropdown-btn:hover {
  background-color: #d1fae5;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15);
}

.ai-slide-dropdown-btn:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.arrow {
  font-size: 1rem;
  margin-left: 0.25rem;
  transition: transform 0.2s ease;
}

.ai-slide-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  width: 450px;
  background: #fff;
  border: 1px solid #b6d7a8;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  z-index: 10;
  padding: 18px 0 18px 0;
}

.ai-slide-dropdown-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1.1rem;
  padding: 0 18px 8px 18px;
  border-bottom: 1px solid #eaeaea;
  position: relative;
}

.ai-tooltip-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.ai-tooltip-icon {
  color: #6b7280;
  font-size: 1.3em;
  cursor: pointer;
  margin-left: 8px;
  transition: color 0.2s;
}

.ai-tooltip-icon:hover,
.ai-tooltip-icon:focus {
  color: #059669;
}

.ai-tooltip-box {
  display: none;
  position: absolute;
  right: -10px;
  bottom: 140%;
  min-width: 250px;
  background: #333;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 100;
  white-space: pre-line;
  border: none;
  line-height: 1.5;
  text-align: left;
}

.ai-tooltip-box::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 18px;
  border-width: 6px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
  /* 아래로 향하는 화살표 */
}

.ai-tooltip-wrap:hover .ai-tooltip-box,
.ai-tooltip-wrap:focus-within .ai-tooltip-box {
  display: block;
}

/* 화살표용: 도서목록 말풍선을 그대로 쓰되, 위치만 화살표 옆으로 */
.ai-tooltip-wrap--arrow {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ai-tooltip-box--arrow {
  display: none;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  min-width: auto;
  width: max-content;
  max-width: 220px;
  padding: 10px 14px;
  white-space: nowrap;
}

.ai-tooltip-wrap--arrow-left .ai-tooltip-box--arrow {
  right: calc(100% + 12px);
  left: auto;
}

.ai-tooltip-wrap--arrow-right .ai-tooltip-box--arrow {
  left: calc(100% + 12px);
  right: auto;
}

.ai-tooltip-box--arrow::after {
  display: none;
}

.ai-slide-dropdown-q {
  transition: background 0.2s, color 0.2s;
  border-radius: 50%;
  padding: 2px 2px 0 2px;
}

.ai-slide-dropdown-q:hover {
  background: #eaf5e6;
  color: #4e7c1b;
}

.ai-slide-dropdown-list {
  max-height: 340px;
  overflow-y: auto;
  padding: 0 28px;
  font-weight: 350;
}

.ai-slide-dropdown-item {
  font-size: 1rem;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: background 0.22s cubic-bezier(.4, 0, .2, 1), color 0.18s;
}

.ai-slide-dropdown-item:hover,
.ai-slide-dropdown-item:focus {
  background: #e5e7eb;
  color: #111827;
  box-shadow: 0 2px 8px rgba(55, 65, 81, 0.06);
}

.ai-slide-dropdown-item.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 420px;
  display: block;
}

.rank-num {
  font-weight: 700;
  color: #4e7c1b;
  min-width: 22px;
  display: inline-block;
}

.ai-slide-main {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
  padding: 0 48px;
  margin-top: 12px;
  min-width: 0;
  overflow: visible;
  overscroll-behavior-x: none;
  touch-action: pan-y;
}

/* 표지+캐러셀: z = 책 뒤(0) → 캐러셀(1) → 표지 카드(2). 어두운 덮개는 ::after 제거 + 카드 inset만 */
.ai-slide-spread-row {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  isolation: isolate;
  perspective: 1200px;
  perspective-origin: left center;
}

.ai-slide-spread-row--compact .ai-slide-carousel-outer {
  right: 0;
  margin-left: 8px;
}

.ai-slide-bookcard-back {
  position: absolute;
  left: -1px;
  /* 사용자 요청: 정확히 1px만 노출되도록 조정 */
  top: 50%;
  z-index: 0;
  pointer-events: none;
  border-radius: 10px;
  background: linear-gradient(145deg, #3d3f52 0%, #5c5f78 55%, #6a6d88 100%);
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.1);
  opacity: 0.98;
  transform: translateY(-50%) rotateY(-5deg) scale(0.995);
  transform-origin: right center;
}

.ai-slide-bookcard-stack {
  z-index: 2;
  position: relative;
  left: 0;
  /* 겹침 기준점 0 */
  flex: none;
  transition: transform 0.4s ease;
}

/* 위: 표지 이미지(남는 세로는 여기서 flex로 채움) / 아래: 글 — 높이는 BASE_BOOK_H·scale만 따름 */
.ai-slide-bookcard--split {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #4d4f6d;
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.12),
    8px 0 20px -6px rgba(0, 0, 0, 0.18),
    inset -10px 0 14px -6px rgba(0, 0, 0, 0.22);
}

.ai-slide-bookcard-media {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  background: #3d3f52;
}

.ai-slide-bookcard-caption {
  flex: 0 0 auto;
  padding: 8px 10px 10px;
  background: #e8e8ea;
  color: #1f2937;
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}

.ai-slide-bookcard-caption .ai-slide-book-title {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0 0 6px;
  width: 100%;
  text-align: left;
  color: #111827;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: keep-all;
}

.ai-slide-bookcard-caption .ai-slide-book-bottom {
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 0.7rem;
  color: #4b5563;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  line-height: 1.3;
}

.ai-slide-bookcard-caption .ai-slide-book-author,
.ai-slide-bookcard-caption .ai-slide-book-publisher {
  font-size: inherit;
  color: inherit;
}

.ai-slide-carousel-outer {
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  position: relative;
  right: 15px;
  box-sizing: border-box;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

/* 캐러셀: 책 뒤판 위, 표지(2) 아래 — 예전 ::after(z4)만 캐러셀 위에 덮어씌웠던 것 제거됨 */
.ai-slide-carousel-outer--paired {
  position: relative;
  z-index: 1;
  margin-left: 10px;
  /* 사용자 요청: 아예 안 겹치게 오른쪽으로 확실히 밀어냄 */
  border-radius: 0 14px 14px 8px;
  box-shadow: none;
}

/* 모바일: 북카드 스택 없을 때 캐러셀만 넓게 */
.ai-slide-carousel-outer--solo {
  flex: 1 1 auto;
  position: relative;
  right: 0;
  max-width: 100%;
  margin-left: 0;
  border-radius: 0;
  box-shadow: none;
  z-index: auto;
}

.ai-slide-bookcard-stack--compact {
  position: relative;
  left: 0;
  flex: none;
}

.ai-slide-carousel-track {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  overflow: visible;
}

.ai-slide-arrow {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: #f4f4f4;
  color: #b6b6b6;
  font-size: 2.1rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s, color 0.2s;
  position: relative;
}

/* 화살표 위치는 wrap이 담당 (툴팁 클리핑 방지) */

.ai-slide-arrow:hover {
  background: #eaeaea;
  color: #4e7c1b;
}

.ai-slide-arrow-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
}

.ai-slide-arrow-wrap.left {
  left: 0;
}

.ai-slide-arrow-wrap.right {
  right: 0;
}

/* 기존 ai-slide-tooltip(흰 말풍선)은 드롭다운 \`?\` 전용으로 유지 */

.ai-slide-images {
  display: flex;
  align-items: center;
  gap: 18px;
  width: 984px;
  height: 328px;
  -webkit-user-select: none;
          user-select: none;
  cursor: grab;
}

.ai-slide-img {
  object-fit: cover;
  border-radius: 12px;
  flex-shrink: 0;
  max-width: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  background: #f4f4f4;
  transition: box-shadow 0.3s, transform 0.3s;
  -webkit-user-drag: none;
  -webkit-user-select: none;
          user-select: none;
}

.ai-slide-img.current {
  box-shadow: 0 6px 24px rgba(60, 60, 80, 0.13);
  transform: scale(1.04);
  z-index: 1;
}

.ai-slide-img.prev,
.ai-slide-img.next {
  opacity: 0.85;
  filter: grayscale(0.15);
}

.ai-slide-footer {
  background: #f8f8f2;
  border-radius: 10px;
  padding: 18px 48px 10px 48px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 32px;
  border-bottom: 3px solid #b6d7a8;
}

.ai-slide-footer-info {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 6px 12px;
  font-size: 0.875rem;
  color: #374151;
  margin-bottom: 1rem;
}

.ai-slide-footer-label {
  font-weight: 600;
  margin-right: 0;
  font-size: 1.1em;
  margin-left: 10px;
  flex: 0 0 auto;
  line-height: 1.45;
}

.ai-slide-footer-title {
  margin-right: 0;
  font-size: 1.05em;
  font-weight: 450;
  margin-left: 0;
  flex: none;
  line-height: 1.45;
  word-break: keep-all;
}

.ai-slide-footer-author {
  color: #6b7280;
  margin-top: 0;
  flex: none;
  margin-left: 15px;
  line-height: 1.5;
}

.ai-slide-footer-tags {
  display: flex;
  gap: 10px;
  margin-top: 2px;
}

.ai-slide-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.ai-slide-meta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.ai-slide-meta-k {
  font-size: 0.82rem;
  color: #6b7280;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  flex: 0 0 auto;
}

.ai-slide-meta-v {
  color: #374151;
  font-weight: 450;
  min-width: 0;
}

.ai-slide-meta-sep {
  color: #9ca3af;
  font-weight: 400;
}

.ai-slide-footer-info .ai-slide-footer-label {
  flex: 0 0 auto;
}

/* 연령대 태그 옆 '?' 도움말 */
.ai-tooltip-wrap--age {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ai-slide-tag-q {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.8);
  color: #374151;
  font-size: 0.85em;
  font-weight: 700;
  border: 1px solid #e5e7eb;
  cursor: default;
}

.ai-tooltip-box--age {
  right: auto;
  left: 0;
  bottom: 145%;
  min-width: 280px;
  max-width: 360px;
}

.ai-slide-footer-tag {
  padding: 3px 12px;
  border-radius: 8px;
  font-size: 0.98rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.ai-slide-footer-tag.green {
  background: #f8faf5;
  color: #7a8c6b;
  border: 1.5px solid #dbe7d1;
  border-radius: 8px;
  padding: 8px 14px 8px 12px;
  font-size: 1.02rem;
  font-weight: 400;
  display: inline-block;
  min-width: 110px;
  box-shadow: 0 1px 4px rgba(122, 140, 107, 0.06);
  line-height: 1.3;
  position: relative;
}

.age-star {
  color: #b6d7a8;
  font-size: 1.1em;
  margin-right: 2px;
  vertical-align: middle;
  font-weight: bold;
  display: inline-block;
  transform: translateY(-1px);
  margin-bottom: 3px;
}

.age-em {
  color: #4e7c1b;
  font-weight: 700;
  font-size: 1.02em;
  letter-spacing: -0.5px;
  margin-right: 2px;
}

.ai-slide-footer-tag.gray {
  background: #eaeaea;
  color: #888;
}

.ai-slide-footer-tag.search {
  background: #f7f7f7;
  color: #b6d7a8;
  cursor: pointer;
  margin-left: auto;
}

.click {
  background: #b6d7a8;
  color: #fff;
  border-radius: 6px;
  padding: 1px 7px;
  margin-left: 6px;
  font-size: 0.95em;
}

.ai-card-loading {
  text-align: center;
  font-size: 1.2rem;
  color: #888;
  margin-top: 120px;
}

/* 스켈레톤 로딩 스타일 */
.ai-skeleton-bookcard {
  width: 270px;
  height: 370px;
  border-radius: 10px 10px 8px 8px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.2s infinite linear;
  margin-right: 12px;
}

.ai-skeleton-carousel {
  display: flex;
  align-items: center;
  gap: 18px;
}

.ai-skeleton-img {
  width: 328px;
  height: 328px;
  border-radius: 12px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.2s infinite linear;
}

.ai-skeleton-footer-info {
  width: 420px;
  height: 22px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.2s infinite linear;
  margin-bottom: 12px;
}

.ai-skeleton-footer-tags {
  display: flex;
  gap: 10px;
}

.ai-skeleton-footer-tag {
  width: 120px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.2s infinite linear;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.ai-slide-dropdown-top50 {
  font-weight: 700;
  color: #4e7c1b;
  background: #eaf5e6;
  padding: 7px 18px 7px 18px;
  font-size: 1.05rem;
  border-radius: 6px;
  margin: 0 0 8px 0;
  text-align: center;
}

.ai-slide-tooltip {
  display: block;
  position: absolute;
  right: -12px;
  bottom: 130%;
  min-width: 180px;
  background: #fff;
  color: #374151;
  font-size: 0.82rem;
  line-height: 1.5;
  border-radius: 0.75rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.13);
  padding: 0.7rem 1rem;
  z-index: 30;
  white-space: pre-line;
  border: 1px solid #e5e7eb;
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px) scale(0.97);
  transition: opacity 0.38s cubic-bezier(.4, 0, .2, 1), transform 0.38s cubic-bezier(.4, 0, .2, 1);
}

.ai-slide-dropdown-q:hover+.ai-slide-tooltip,
.ai-slide-dropdown-q:focus+.ai-slide-tooltip {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(-8px) scale(1.01);
}

.ai-slide-tooltip::after {
  content: '';
  position: absolute;
  bottom: -12px;
  right: 18px;
  border-width: 12px 10px 0 10px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.04));
}

.ai-slide-carousel-fade {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 100%;
  pointer-events: none;
  z-index: 3;
  background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0.01) 80%, transparent 100%);
}

.ai-slide-bookcard-bgimg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  /* 원본 표지 전체(세로·가로)가 잘리지 않게 */
  object-fit: contain;
  object-position: center center;
  background-color: #3d3f52;
  display: block;
  z-index: 0;
  pointer-events: none;
}

@media (min-width: 720px) {
  .ai-slide-header {
    align-items: center;
  }

  .ai-slide-header-main {
    display: contents;
  }

  .ai-slide-header-row1 {
    grid-column: unset;
    grid-row: unset;
    order: 1;
    margin-right: 12px;
    flex: 0 1 auto;
    min-width: 0;
  }

  .ai-slide-title {
    grid-column: unset;
    grid-row: unset;
    order: unset;
    margin-right: 12px;
    flex: 0 0 auto;
  }

  .ai-slide-desc {
    grid-column: unset;
    grid-row: unset;
    order: 2;
    flex: 1 1 220px;
    min-width: 0;
  }

  .ai-slide-dropdown-wrap {
    grid-column: unset;
    grid-row: unset;
    order: 3;
    margin-left: auto;
    justify-self: unset;
  }

  .ai-slide-footer-info {
    flex-wrap: nowrap;
    align-items: center;
  }

  .ai-slide-footer-title {
    flex: none;
  }

  .ai-slide-footer-author {
    flex: none;
    margin-left: 12px;
    text-align: left;
  }
}

@media (max-width: 719px) {
  .ai-slide-root {
    margin-top: 48px;
    border-radius: 14px;
  }

  .ai-slide-header {
    padding: 20px 16px 0 16px;
  }

  .ai-slide-dropdown {
    width: min(calc(100vw - 32px), 450px);
    max-width: calc(100vw - 24px);
  }

  .ai-slide-main {
    padding: 0 12px;
  }

  .ai-skeleton-bookcard {
    display: none;
  }

  .ai-skeleton-carousel {
    flex: 1 1;
    width: 100%;
    justify-content: center;
  }

  .ai-slide-footer {
    padding: 16px 16px 12px 16px;
    margin-top: 20px;
  }

  .ai-slide-footer-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  }

  .ai-slide-footer-label {
    margin-left: 0;
    font-size: 0.9rem;
    color: #6b7280;
  }

  .ai-slide-footer-title {
    width: 100%;
    margin-left: 0;
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.4;
  }

  .ai-slide-footer-author {
    width: 100%;
    margin-left: 0;
    text-align: left;
    font-size: 0.95rem;
    color: #666;
  }

  .ai-slide-footer-tag.green {
    max-width: 100%;
    box-sizing: border-box;
  }

  .skeleton {
    background-color: #e5e7eb;
    background-image: linear-gradient(90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 100%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 8px;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }

    100% {
      background-position: -200% 0;
    }
  }

  .ai-slide-skeleton-media {
    width: 100%;
    height: 280px;
    border-radius: 12px 12px 0 0;
  }

  .ai-slide-skeleton-text {
    height: 16px;
    margin-bottom: 8px;
  }

  .ai-slide-skeleton-text-short {
    width: 60%;
    height: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8DAA8D;EAC9D,gCAAgC;EAChC,6CAA6C;EAC7C,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,oEAAoE;AACtE;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,MAAM;EACN,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,0EAA0E;EAC1E,0CAA0C;EAC1C,aAAa;EACb,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,UAAU;EACV,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB;;;+CAG6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;EACvD,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,UAAU;EACV,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,uCAAuC;EACvC,gGAAgG;AAClG;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,sDAAsD;EACtD,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,6FAA6F;AAC/F;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB;;;oCAGgC;IAChC,0BAA0B;IAC1B,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* AI 추천 카드 콘텐츠 스타일 */\r\n.ai-card-container {\r\n  max-width: 900px;\r\n  margin: 40px auto;\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\r\n  padding: 32px 32px 24px 32px;\r\n  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;\r\n}\r\n\r\n.ai-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  margin-bottom: 18px;\r\n  position: relative;\r\n}\r\n\r\n.ai-card-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  border-bottom: 2px solid #b6d7a8;\r\n  padding-bottom: 2px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.ai-card-desc {\r\n  font-size: 1rem;\r\n  color: #444;\r\n}\r\n\r\n.ai-card-ai {\r\n  color: #4e7c1b;\r\n  font-weight: 600;\r\n}\r\n\r\n.ai-card-dropdown-wrap {\r\n  margin-left: auto;\r\n  position: relative;\r\n}\r\n\r\n.ai-card-dropdown-btn {\r\n  background: #eaf5e6;\r\n  border: 1px solid #b6d7a8;\r\n  border-radius: 6px;\r\n  padding: 6px 18px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  color: #4e7c1b;\r\n  font-weight: 600;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.ai-card-dropdown-btn:hover {\r\n  background: #d9f2c7;\r\n}\r\n\r\n.arrow {\r\n  font-size: 0.9em;\r\n  margin-left: 4px;\r\n}\r\n\r\n.ai-card-dropdown {\r\n  position: absolute;\r\n  top: 38px;\r\n  right: 0;\r\n  width: 340px;\r\n  background: #fff;\r\n  border: 1px solid #b6d7a8;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\r\n  z-index: 10;\r\n  padding: 12px 0 12px 0;\r\n}\r\n\r\n.ai-card-dropdown-title {\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n  padding: 0 18px 8px 18px;\r\n  border-bottom: 1px solid #eaeaea;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ai-card-dropdown-q {\r\n  color: #b6d7a8;\r\n  font-size: 1em;\r\n  margin-left: 4px;\r\n}\r\n\r\n.ai-card-dropdown-list {\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n  padding: 0 18px;\r\n}\r\n\r\n.ai-card-dropdown-item {\r\n  font-size: 1rem;\r\n  padding: 4px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.rank-num {\r\n  font-weight: 700;\r\n  color: #4e7c1b;\r\n  min-width: 22px;\r\n  display: inline-block;\r\n}\r\n\r\n.ai-card-main {\r\n  display: flex;\r\n  gap: 32px;\r\n  align-items: flex-start;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.ai-card-carousel {\r\n  width: 320px;\r\n  height: 420px;\r\n  background: #f4f4f4;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.ai-card-carousel-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 12px;\r\n  transition: opacity 0.5s;\r\n}\r\n\r\n.ai-card-carousel-placeholder {\r\n  color: #aaa;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.ai-card-book-info {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.ai-card-book-title {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.ai-card-book-author {\r\n  color: #666;\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.ai-card-book-pub {\r\n  color: #999;\r\n  font-size: 0.98rem;\r\n}\r\n\r\n.ai-card-book-status {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.ai-card-book-loan {\r\n  background: #eaeaea;\r\n  color: #b6d7a8;\r\n  padding: 2px 10px;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.ai-card-book-ebook {\r\n  background: #f7f7f7;\r\n  color: #aaa;\r\n  padding: 2px 10px;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.ai-card-footer {\r\n  background: #f8f8f2;\r\n  border-radius: 10px;\r\n  padding: 14px 18px 10px 18px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.ai-card-footer-info {\r\n  font-size: 1.05rem;\r\n  color: #444;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.ai-card-footer-label {\r\n  color: #888;\r\n  margin-right: 8px;\r\n}\r\n\r\n.ai-card-footer-title {\r\n  font-weight: 700;\r\n  margin-right: 8px;\r\n}\r\n\r\n.ai-card-footer-author {\r\n  color: #666;\r\n}\r\n\r\n.ai-card-footer-tags {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.ai-card-footer-tag {\r\n  padding: 3px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.98rem;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ai-card-footer-tag.green {\r\n  background: #eaf5e6;\r\n  color: #4e7c1b;\r\n}\r\n\r\n.ai-card-footer-tag.gray {\r\n  background: #eaeaea;\r\n  color: #888;\r\n}\r\n\r\n.ai-card-footer-tag.search {\r\n  background: #f7f7f7;\r\n  color: #b6d7a8;\r\n  cursor: pointer;\r\n}\r\n\r\n.click {\r\n  background: #b6d7a8;\r\n  color: #fff;\r\n  border-radius: 6px;\r\n  padding: 1px 7px;\r\n  margin-left: 6px;\r\n  font-size: 0.95em;\r\n}\r\n\r\n/* AI 캐러셀 스타일 */\r\n.ai-carousel-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 32px;\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\r\n  padding: 32px 48px;\r\n  max-width: 1100px;\r\n  margin: 40px auto;\r\n  min-height: 400px;\r\n}\r\n\r\n.ai-carousel-bookcard {\r\n  width: 260px;\r\n  min-width: 220px;\r\n  height: 370px;\r\n  background: linear-gradient(160deg, #6d7290 80%, #8a8fa8 100%);\r\n  border-radius: 10px 10px 8px 8px;\r\n  box-shadow: 0 6px 24px rgba(60, 60, 80, 0.13);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  position: relative;\r\n  margin-right: 12px;\r\n}\r\n\r\n.ai-carousel-bookcard-inner {\r\n  width: 100%;\r\n  padding: 32px 20px 24px 20px;\r\n  color: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;\r\n}\r\n\r\n.ai-carousel-book-title {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  margin-bottom: 8px;\r\n  word-break: keep-all;\r\n}\r\n\r\n.ai-carousel-book-author {\r\n  font-size: 1.05rem;\r\n  color: #d2d6e0;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.ai-carousel-book-publisher {\r\n  font-size: 1.02rem;\r\n  color: #d2d6e0;\r\n}\r\n\r\n.ai-carousel-images {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 328px;\r\n  height: 328px;\r\n  background: #f4f4f4;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  overflow: hidden;\r\n}\r\n\r\n.ai-carousel-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 12px;\r\n  transition: opacity 0.5s;\r\n}\r\n\r\n.ai-card-loading {\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  color: #888;\r\n  margin-top: 120px;\r\n}\r\n\r\n/* 슬라이드형 북카드 캐러셀 스타일 */\r\n.ai-slide-root {\r\n  max-width: 1260px;\r\n  margin: 100px auto 0 auto;\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\r\n  padding: 0 0 24px 0;\r\n  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;\r\n  overflow-x: visible;\r\n}\r\n\r\n.ai-slide-header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  gap: 14px 18px;\r\n  padding: 32px 48px 0 48px;\r\n  position: relative;\r\n}\r\n\r\n.ai-slide-header-main {\r\n  flex: 1 1 280px;\r\n  min-width: 0;\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  grid-template-rows: auto auto;\r\n  gap: 10px 12px;\r\n  align-items: center;\r\n}\r\n\r\n.ai-slide-header-row1 {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 10px 16px;\r\n  min-width: 0;\r\n}\r\n\r\n.ai-slide-catalog-tabs {\r\n  display: inline-flex;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  border: 1px solid #b6d7a8;\r\n  flex-shrink: 0;\r\n  background: #f4faf0;\r\n}\r\n\r\n.ai-slide-catalog-tab {\r\n  padding: 7px 18px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: #4a5a42;\r\n  font-family: inherit;\r\n  line-height: 1.2;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.ai-slide-catalog-tab:hover {\r\n  background: rgba(107, 159, 62, 0.12);\r\n  color: #3d5c24;\r\n}\r\n\r\n.ai-slide-catalog-tab.is-active {\r\n  background: #6b9f3e;\r\n  color: #fff;\r\n}\r\n\r\n.ai-slide-catalog-tab.is-active:hover {\r\n  background: #5d8a35;\r\n  color: #fff;\r\n}\r\n\r\n.ai-slide-title {\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  border-bottom: 2px solid #b6d7a8;\r\n  padding-bottom: 2px;\r\n  margin-right: 0;\r\n  line-height: 1.35;\r\n  min-width: 0;\r\n  justify-self: start;\r\n  width: fit-content;\r\n  max-width: 100%;\r\n  display: inline-block;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.ai-slide-desc {\r\n  font-size: 1rem;\r\n  color: #444;\r\n  line-height: 1.55;\r\n  word-break: keep-all;\r\n  overflow-wrap: break-word;\r\n  max-width: 100%;\r\n  grid-column: 1 / -1;\r\n  grid-row: 2;\r\n}\r\n\r\n.ai-slide-desc-sub {\r\n  display: inline-block;\r\n  margin-left: 10px;\r\n  color: #6b7280;\r\n  font-size: 0.92em;\r\n  font-weight: 450;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ai-slide-root-note {\r\n  max-width: 1260px;\r\n  margin: 10px auto 0 auto;\r\n  padding: 0 48px;\r\n  color: #6b7280;\r\n  font-size: 0.92rem;\r\n  line-height: 1.5;\r\n  word-break: keep-all;\r\n  text-align: right;\r\n}\r\n\r\n@media (max-width: 719px) {\r\n  .ai-slide-root-note {\r\n    padding: 0 16px;\r\n  }\r\n}\r\n\r\n.ai-slide-ai {\r\n  color: #4e7c1b;\r\n  font-weight: 600;\r\n}\r\n\r\n.ai-slide-dropdown-wrap {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n  grid-column: 2;\r\n  grid-row: 1;\r\n  justify-self: end;\r\n  align-self: center;\r\n  margin-left: 0;\r\n}\r\n\r\n.ai-slide-dropdown-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #059669;\r\n  background-color: #ecfdf5;\r\n  padding: 0.625rem 1.25rem;\r\n  border-radius: 0.5rem;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #d1fae5;\r\n  gap: 0.375rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.ai-slide-dropdown-btn:hover {\r\n  background-color: #d1fae5;\r\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15);\r\n}\r\n\r\n.ai-slide-dropdown-btn:active {\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.arrow {\r\n  font-size: 1rem;\r\n  margin-left: 0.25rem;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.ai-slide-dropdown {\r\n  position: absolute;\r\n  top: 38px;\r\n  right: 0;\r\n  width: 450px;\r\n  background: #fff;\r\n  border: 1px solid #b6d7a8;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\r\n  z-index: 10;\r\n  padding: 18px 0 18px 0;\r\n}\r\n\r\n.ai-slide-dropdown-title {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n  padding: 0 18px 8px 18px;\r\n  border-bottom: 1px solid #eaeaea;\r\n  position: relative;\r\n}\r\n\r\n.ai-tooltip-wrap {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ai-tooltip-icon {\r\n  color: #6b7280;\r\n  font-size: 1.3em;\r\n  cursor: pointer;\r\n  margin-left: 8px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.ai-tooltip-icon:hover,\r\n.ai-tooltip-icon:focus {\r\n  color: #059669;\r\n}\r\n\r\n.ai-tooltip-box {\r\n  display: none;\r\n  position: absolute;\r\n  right: -10px;\r\n  bottom: 140%;\r\n  min-width: 250px;\r\n  background: #333;\r\n  color: #fff;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\r\n  padding: 12px 16px;\r\n  z-index: 100;\r\n  white-space: pre-line;\r\n  border: none;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n}\r\n\r\n.ai-tooltip-box::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 18px;\r\n  border-width: 6px;\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent;\r\n  /* 아래로 향하는 화살표 */\r\n}\r\n\r\n.ai-tooltip-wrap:hover .ai-tooltip-box,\r\n.ai-tooltip-wrap:focus-within .ai-tooltip-box {\r\n  display: block;\r\n}\r\n\r\n/* 화살표용: 도서목록 말풍선을 그대로 쓰되, 위치만 화살표 옆으로 */\r\n.ai-tooltip-wrap--arrow {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.ai-tooltip-box--arrow {\r\n  display: none;\r\n  bottom: auto;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  min-width: auto;\r\n  width: max-content;\r\n  max-width: 220px;\r\n  padding: 10px 14px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ai-tooltip-wrap--arrow-left .ai-tooltip-box--arrow {\r\n  right: calc(100% + 12px);\r\n  left: auto;\r\n}\r\n\r\n.ai-tooltip-wrap--arrow-right .ai-tooltip-box--arrow {\r\n  left: calc(100% + 12px);\r\n  right: auto;\r\n}\r\n\r\n.ai-tooltip-box--arrow::after {\r\n  display: none;\r\n}\r\n\r\n.ai-slide-dropdown-q {\r\n  transition: background 0.2s, color 0.2s;\r\n  border-radius: 50%;\r\n  padding: 2px 2px 0 2px;\r\n}\r\n\r\n.ai-slide-dropdown-q:hover {\r\n  background: #eaf5e6;\r\n  color: #4e7c1b;\r\n}\r\n\r\n.ai-slide-dropdown-list {\r\n  max-height: 340px;\r\n  overflow-y: auto;\r\n  padding: 0 28px;\r\n  font-weight: 350;\r\n}\r\n\r\n.ai-slide-dropdown-item {\r\n  font-size: 1rem;\r\n  padding: 4px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 0.5rem;\r\n  padding: 0.5rem 0.75rem;\r\n  cursor: pointer;\r\n  transition: background 0.22s cubic-bezier(.4, 0, .2, 1), color 0.18s;\r\n}\r\n\r\n.ai-slide-dropdown-item:hover,\r\n.ai-slide-dropdown-item:focus {\r\n  background: #e5e7eb;\r\n  color: #111827;\r\n  box-shadow: 0 2px 8px rgba(55, 65, 81, 0.06);\r\n}\r\n\r\n.ai-slide-dropdown-item.ellipsis {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 420px;\r\n  display: block;\r\n}\r\n\r\n.rank-num {\r\n  font-weight: 700;\r\n  color: #4e7c1b;\r\n  min-width: 22px;\r\n  display: inline-block;\r\n}\r\n\r\n.ai-slide-main {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  gap: 0;\r\n  padding: 0 48px;\r\n  margin-top: 12px;\r\n  min-width: 0;\r\n  overflow: visible;\r\n  overscroll-behavior-x: none;\r\n  touch-action: pan-y;\r\n}\r\n\r\n/* 표지+캐러셀: z = 책 뒤(0) → 캐러셀(1) → 표지 카드(2). 어두운 덮개는 ::after 제거 + 카드 inset만 */\r\n.ai-slide-spread-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  position: relative;\r\n  isolation: isolate;\r\n  perspective: 1200px;\r\n  perspective-origin: left center;\r\n}\r\n\r\n.ai-slide-spread-row--compact .ai-slide-carousel-outer {\r\n  right: 0;\r\n  margin-left: 8px;\r\n}\r\n\r\n.ai-slide-bookcard-back {\r\n  position: absolute;\r\n  left: -1px;\r\n  /* 사용자 요청: 정확히 1px만 노출되도록 조정 */\r\n  top: 50%;\r\n  z-index: 0;\r\n  pointer-events: none;\r\n  border-radius: 10px;\r\n  background: linear-gradient(145deg, #3d3f52 0%, #5c5f78 55%, #6a6d88 100%);\r\n  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.1);\r\n  opacity: 0.98;\r\n  transform: translateY(-50%) rotateY(-5deg) scale(0.995);\r\n  transform-origin: right center;\r\n}\r\n\r\n.ai-slide-bookcard-stack {\r\n  z-index: 2;\r\n  position: relative;\r\n  left: 0;\r\n  /* 겹침 기준점 0 */\r\n  flex: none;\r\n  transition: transform 0.4s ease;\r\n}\r\n\r\n/* 위: 표지 이미지(남는 세로는 여기서 flex로 채움) / 아래: 글 — 높이는 BASE_BOOK_H·scale만 따름 */\r\n.ai-slide-bookcard--split {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #4d4f6d;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow:\r\n    0 4px 16px rgba(0, 0, 0, 0.12),\r\n    8px 0 20px -6px rgba(0, 0, 0, 0.18),\r\n    inset -10px 0 14px -6px rgba(0, 0, 0, 0.22);\r\n}\r\n\r\n.ai-slide-bookcard-media {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  width: 100%;\r\n  background: #3d3f52;\r\n}\r\n\r\n.ai-slide-bookcard-caption {\r\n  flex: 0 0 auto;\r\n  padding: 8px 10px 10px;\r\n  background: #e8e8ea;\r\n  color: #1f2937;\r\n  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;\r\n}\r\n\r\n.ai-slide-bookcard-caption .ai-slide-book-title {\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n  margin: 0 0 6px;\r\n  width: 100%;\r\n  text-align: left;\r\n  color: #111827;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  word-break: keep-all;\r\n}\r\n\r\n.ai-slide-bookcard-caption .ai-slide-book-bottom {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 0.7rem;\r\n  color: #4b5563;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  text-align: left;\r\n  line-height: 1.3;\r\n}\r\n\r\n.ai-slide-bookcard-caption .ai-slide-book-author,\r\n.ai-slide-bookcard-caption .ai-slide-book-publisher {\r\n  font-size: inherit;\r\n  color: inherit;\r\n}\r\n\r\n.ai-slide-carousel-outer {\r\n  overflow: hidden;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  right: 15px;\r\n  box-sizing: border-box;\r\n  overscroll-behavior: contain;\r\n  touch-action: pan-y;\r\n}\r\n\r\n/* 캐러셀: 책 뒤판 위, 표지(2) 아래 — 예전 ::after(z4)만 캐러셀 위에 덮어씌웠던 것 제거됨 */\r\n.ai-slide-carousel-outer--paired {\r\n  position: relative;\r\n  z-index: 1;\r\n  margin-left: 10px;\r\n  /* 사용자 요청: 아예 안 겹치게 오른쪽으로 확실히 밀어냄 */\r\n  border-radius: 0 14px 14px 8px;\r\n  box-shadow: none;\r\n}\r\n\r\n/* 모바일: 북카드 스택 없을 때 캐러셀만 넓게 */\r\n.ai-slide-carousel-outer--solo {\r\n  flex: 1 1 auto;\r\n  position: relative;\r\n  right: 0;\r\n  max-width: 100%;\r\n  margin-left: 0;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  z-index: auto;\r\n}\r\n\r\n.ai-slide-bookcard-stack--compact {\r\n  position: relative;\r\n  left: 0;\r\n  flex: none;\r\n}\r\n\r\n.ai-slide-carousel-track {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n  will-change: transform;\r\n  overflow: visible;\r\n}\r\n\r\n.ai-slide-arrow {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: #f4f4f4;\r\n  color: #b6b6b6;\r\n  font-size: 2.1rem;\r\n  font-weight: 700;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  transition: background 0.2s, color 0.2s;\r\n  position: relative;\r\n}\r\n\r\n/* 화살표 위치는 wrap이 담당 (툴팁 클리핑 방지) */\r\n\r\n.ai-slide-arrow:hover {\r\n  background: #eaeaea;\r\n  color: #4e7c1b;\r\n}\r\n\r\n.ai-slide-arrow-wrap {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  z-index: 3;\r\n}\r\n\r\n.ai-slide-arrow-wrap.left {\r\n  left: 0;\r\n}\r\n\r\n.ai-slide-arrow-wrap.right {\r\n  right: 0;\r\n}\r\n\r\n/* 기존 ai-slide-tooltip(흰 말풍선)은 드롭다운 `?` 전용으로 유지 */\r\n\r\n.ai-slide-images {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  width: 984px;\r\n  height: 328px;\r\n  user-select: none;\r\n  cursor: grab;\r\n}\r\n\r\n.ai-slide-img {\r\n  object-fit: cover;\r\n  border-radius: 12px;\r\n  flex-shrink: 0;\r\n  max-width: none;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  background: #f4f4f4;\r\n  transition: box-shadow 0.3s, transform 0.3s;\r\n  -webkit-user-drag: none;\r\n  user-select: none;\r\n}\r\n\r\n.ai-slide-img.current {\r\n  box-shadow: 0 6px 24px rgba(60, 60, 80, 0.13);\r\n  transform: scale(1.04);\r\n  z-index: 1;\r\n}\r\n\r\n.ai-slide-img.prev,\r\n.ai-slide-img.next {\r\n  opacity: 0.85;\r\n  filter: grayscale(0.15);\r\n}\r\n\r\n.ai-slide-footer {\r\n  background: #f8f8f2;\r\n  border-radius: 10px;\r\n  padding: 18px 48px 10px 48px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-top: 32px;\r\n  border-bottom: 3px solid #b6d7a8;\r\n}\r\n\r\n.ai-slide-footer-info {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  gap: 6px 12px;\r\n  font-size: 0.875rem;\r\n  color: #374151;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.ai-slide-footer-label {\r\n  font-weight: 600;\r\n  margin-right: 0;\r\n  font-size: 1.1em;\r\n  margin-left: 10px;\r\n  flex: 0 0 auto;\r\n  line-height: 1.45;\r\n}\r\n\r\n.ai-slide-footer-title {\r\n  margin-right: 0;\r\n  font-size: 1.05em;\r\n  font-weight: 450;\r\n  margin-left: 0;\r\n  flex: none;\r\n  line-height: 1.45;\r\n  word-break: keep-all;\r\n}\r\n\r\n.ai-slide-footer-author {\r\n  color: #6b7280;\r\n  margin-top: 0;\r\n  flex: none;\r\n  margin-left: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.ai-slide-footer-tags {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.ai-slide-meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.ai-slide-meta-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.ai-slide-meta-k {\r\n  font-size: 0.82rem;\r\n  color: #6b7280;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: #f3f4f6;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.ai-slide-meta-v {\r\n  color: #374151;\r\n  font-weight: 450;\r\n  min-width: 0;\r\n}\r\n\r\n.ai-slide-meta-sep {\r\n  color: #9ca3af;\r\n  font-weight: 400;\r\n}\r\n\r\n.ai-slide-footer-info .ai-slide-footer-label {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* 연령대 태그 옆 '?' 도움말 */\r\n.ai-tooltip-wrap--age {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.ai-slide-tag-q {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  margin-left: 8px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  color: #374151;\r\n  font-size: 0.85em;\r\n  font-weight: 700;\r\n  border: 1px solid #e5e7eb;\r\n  cursor: default;\r\n}\r\n\r\n.ai-tooltip-box--age {\r\n  right: auto;\r\n  left: 0;\r\n  bottom: 145%;\r\n  min-width: 280px;\r\n  max-width: 360px;\r\n}\r\n\r\n.ai-slide-footer-tag {\r\n  padding: 3px 12px;\r\n  border-radius: 8px;\r\n  font-size: 0.98rem;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.ai-slide-footer-tag.green {\r\n  background: #f8faf5;\r\n  color: #7a8c6b;\r\n  border: 1.5px solid #dbe7d1;\r\n  border-radius: 8px;\r\n  padding: 8px 14px 8px 12px;\r\n  font-size: 1.02rem;\r\n  font-weight: 400;\r\n  display: inline-block;\r\n  min-width: 110px;\r\n  box-shadow: 0 1px 4px rgba(122, 140, 107, 0.06);\r\n  line-height: 1.3;\r\n  position: relative;\r\n}\r\n\r\n.age-star {\r\n  color: #b6d7a8;\r\n  font-size: 1.1em;\r\n  margin-right: 2px;\r\n  vertical-align: middle;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n  transform: translateY(-1px);\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.age-em {\r\n  color: #4e7c1b;\r\n  font-weight: 700;\r\n  font-size: 1.02em;\r\n  letter-spacing: -0.5px;\r\n  margin-right: 2px;\r\n}\r\n\r\n.ai-slide-footer-tag.gray {\r\n  background: #eaeaea;\r\n  color: #888;\r\n}\r\n\r\n.ai-slide-footer-tag.search {\r\n  background: #f7f7f7;\r\n  color: #b6d7a8;\r\n  cursor: pointer;\r\n  margin-left: auto;\r\n}\r\n\r\n.click {\r\n  background: #b6d7a8;\r\n  color: #fff;\r\n  border-radius: 6px;\r\n  padding: 1px 7px;\r\n  margin-left: 6px;\r\n  font-size: 0.95em;\r\n}\r\n\r\n.ai-card-loading {\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  color: #888;\r\n  margin-top: 120px;\r\n}\r\n\r\n/* 스켈레톤 로딩 스타일 */\r\n.ai-skeleton-bookcard {\r\n  width: 270px;\r\n  height: 370px;\r\n  border-radius: 10px 10px 8px 8px;\r\n  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);\r\n  background-size: 400% 100%;\r\n  animation: skeleton-loading 1.2s infinite linear;\r\n  margin-right: 12px;\r\n}\r\n\r\n.ai-skeleton-carousel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n}\r\n\r\n.ai-skeleton-img {\r\n  width: 328px;\r\n  height: 328px;\r\n  border-radius: 12px;\r\n  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);\r\n  background-size: 400% 100%;\r\n  animation: skeleton-loading 1.2s infinite linear;\r\n}\r\n\r\n.ai-skeleton-footer-info {\r\n  width: 420px;\r\n  height: 22px;\r\n  border-radius: 8px;\r\n  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);\r\n  background-size: 400% 100%;\r\n  animation: skeleton-loading 1.2s infinite linear;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.ai-skeleton-footer-tags {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.ai-skeleton-footer-tag {\r\n  width: 120px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n  background: linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%);\r\n  background-size: 400% 100%;\r\n  animation: skeleton-loading 1.2s infinite linear;\r\n}\r\n\r\n@keyframes skeleton-loading {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n\r\n  100% {\r\n    background-position: 0 50%;\r\n  }\r\n}\r\n\r\n.ai-slide-dropdown-top50 {\r\n  font-weight: 700;\r\n  color: #4e7c1b;\r\n  background: #eaf5e6;\r\n  padding: 7px 18px 7px 18px;\r\n  font-size: 1.05rem;\r\n  border-radius: 6px;\r\n  margin: 0 0 8px 0;\r\n  text-align: center;\r\n}\r\n\r\n.ai-slide-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  right: -12px;\r\n  bottom: 130%;\r\n  min-width: 180px;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 0.82rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.75rem;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.13);\r\n  padding: 0.7rem 1rem;\r\n  z-index: 30;\r\n  white-space: pre-line;\r\n  border: 1px solid #e5e7eb;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transform: translateY(10px) scale(0.97);\r\n  transition: opacity 0.38s cubic-bezier(.4, 0, .2, 1), transform 0.38s cubic-bezier(.4, 0, .2, 1);\r\n}\r\n\r\n.ai-slide-dropdown-q:hover+.ai-slide-tooltip,\r\n.ai-slide-dropdown-q:focus+.ai-slide-tooltip {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  transform: translateY(-8px) scale(1.01);\r\n}\r\n\r\n.ai-slide-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -12px;\r\n  right: 18px;\r\n  border-width: 12px 10px 0 10px;\r\n  border-style: solid;\r\n  border-color: #fff transparent transparent transparent;\r\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.04));\r\n}\r\n\r\n.ai-slide-carousel-fade {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 60px;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  z-index: 3;\r\n  background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0.01) 80%, transparent 100%);\r\n}\r\n\r\n.ai-slide-bookcard-bgimg {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  /* 원본 표지 전체(세로·가로)가 잘리지 않게 */\r\n  object-fit: contain;\r\n  object-position: center center;\r\n  background-color: #3d3f52;\r\n  display: block;\r\n  z-index: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (min-width: 720px) {\r\n  .ai-slide-header {\r\n    align-items: center;\r\n  }\r\n\r\n  .ai-slide-header-main {\r\n    display: contents;\r\n  }\r\n\r\n  .ai-slide-header-row1 {\r\n    grid-column: unset;\r\n    grid-row: unset;\r\n    order: 1;\r\n    margin-right: 12px;\r\n    flex: 0 1 auto;\r\n    min-width: 0;\r\n  }\r\n\r\n  .ai-slide-title {\r\n    grid-column: unset;\r\n    grid-row: unset;\r\n    order: unset;\r\n    margin-right: 12px;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .ai-slide-desc {\r\n    grid-column: unset;\r\n    grid-row: unset;\r\n    order: 2;\r\n    flex: 1 1 220px;\r\n    min-width: 0;\r\n  }\r\n\r\n  .ai-slide-dropdown-wrap {\r\n    grid-column: unset;\r\n    grid-row: unset;\r\n    order: 3;\r\n    margin-left: auto;\r\n    justify-self: unset;\r\n  }\r\n\r\n  .ai-slide-footer-info {\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n  }\r\n\r\n  .ai-slide-footer-title {\r\n    flex: none;\r\n  }\r\n\r\n  .ai-slide-footer-author {\r\n    flex: none;\r\n    margin-left: 12px;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n@media (max-width: 719px) {\r\n  .ai-slide-root {\r\n    margin-top: 48px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .ai-slide-header {\r\n    padding: 20px 16px 0 16px;\r\n  }\r\n\r\n  .ai-slide-dropdown {\r\n    width: min(calc(100vw - 32px), 450px);\r\n    max-width: calc(100vw - 24px);\r\n  }\r\n\r\n  .ai-slide-main {\r\n    padding: 0 12px;\r\n  }\r\n\r\n  .ai-skeleton-bookcard {\r\n    display: none;\r\n  }\r\n\r\n  .ai-skeleton-carousel {\r\n    flex: 1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .ai-slide-footer {\r\n    padding: 16px 16px 12px 16px;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .ai-slide-footer-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .ai-slide-footer-label {\r\n    margin-left: 0;\r\n    font-size: 0.9rem;\r\n    color: #6b7280;\r\n  }\r\n\r\n  .ai-slide-footer-title {\r\n    width: 100%;\r\n    margin-left: 0;\r\n    font-size: 1.15rem;\r\n    font-weight: 700;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .ai-slide-footer-author {\r\n    width: 100%;\r\n    margin-left: 0;\r\n    text-align: left;\r\n    font-size: 0.95rem;\r\n    color: #666;\r\n  }\r\n\r\n  .ai-slide-footer-tag.green {\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .skeleton {\r\n    background-color: #e5e7eb;\r\n    background-image: linear-gradient(90deg,\r\n        rgba(255, 255, 255, 0) 0,\r\n        rgba(255, 255, 255, 0.5) 50%,\r\n        rgba(255, 255, 255, 0) 100%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s infinite;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  @keyframes skeleton-loading {\r\n    0% {\r\n      background-position: 200% 0;\r\n    }\r\n\r\n    100% {\r\n      background-position: -200% 0;\r\n    }\r\n  }\r\n\r\n  .ai-slide-skeleton-media {\r\n    width: 100%;\r\n    height: 280px;\r\n    border-radius: 12px 12px 0 0;\r\n  }\r\n\r\n  .ai-slide-skeleton-text {\r\n    height: 16px;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .ai-slide-skeleton-text-short {\r\n    width: 60%;\r\n    height: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
